import * as R from 'ramda'

export const quoteStatus: {
  [key: string]: string;
} = {
  QUOTING: 'Quoting',
  UNDERWRITING: 'Underwriting',
  PROPOSE: 'Propose',
  CLOSED: 'Closed'
}

export const quoteStatusKeys = R.keys(quoteStatus)
export const quoteStatusValues = R.values(quoteStatus)

export const quoteStatusClass: {
  [key: string]: string;
} = {
  QUOTING: 'c-quote-list__status-quoting',
  PROPOSE: 'c-quote-list__status-propose',
  UNDERWRITING: 'c-quote-list__status-underwriting',
  CLOSED: 'c-quote-list__status-closed'
}

export const quoteStatusClassKeys = R.keys(quoteStatus)
export const quoteStatusClassValues = R.values(quoteStatus)

export const quoteType: {
  [key: string]: string;
} = {
  RENEWAL: 'Renewal',
  NEW_BUSINESS: 'New Business',
  REWRITE: 'Rewrite',
  BOR: 'BOR',
  REMARKET: 'Remarket'
}

export const quoteTypeKeys = R.keys(quoteType)
export const quoteTypeValues = R.values(quoteType)
